import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import LoginScreen from './components/LoginScreen';
import Dashboard from './components/Dashboard';
import LandingPage from './components/LandingPage';
import PrivacyPolicy from './components/PrivacyPolicy';

function AppContent() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();

  // Restore session on mount //test
  useEffect(() => {
    const savedSession = localStorage.getItem('repugate_session');
    if (savedSession) {
      try {
        const session = JSON.parse(savedSession);
        // Check if session is still valid (not older than 24 hours)
        const sessionAge = Date.now() - (session.timestamp || 0);
        const ONE_DAY = 24 * 60 * 60 * 1000;
        
        if (sessionAge < ONE_DAY) {
          setIsLoggedIn(true);
          navigate('/dashboard');
        } else {
          // Session expired
          localStorage.removeItem('repugate_session');
        }
      } catch (err) {
        console.error('Failed to restore session:', err);
        localStorage.removeItem('repugate_session');
      }
    }
  }, [navigate]);

  const handleLoginSuccess = (loginData) => {
    const { user, page, accessToken } = loginData;

    // Store session with timestamp for expiration tracking
    const session = {
      user,
      page,
      pageAccessToken: accessToken,
      timestamp: Date.now()
    };

    localStorage.setItem('repugate_session', JSON.stringify(session));
    sessionStorage.setItem('repugate_session', JSON.stringify(session)); // Keep sessionStorage too for immediate access
    setIsLoggedIn(true);
    navigate('/dashboard');
  };

  const handleLogout = () => {
    localStorage.removeItem('repugate_session');
    sessionStorage.removeItem('repugate_session');
    setIsLoggedIn(false);
    navigate('/');
  };

  const handleGetStarted = () => {
    navigate('/login');
  };

  return (
    <Routes>
      <Route path="/" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <LandingPage onGetStarted={handleGetStarted} />} />
      <Route path="/login" element={<LoginScreen onLoginSuccess={handleLoginSuccess} />} />
      <Route path="/dashboard" element={isLoggedIn ? <Dashboard onLogout={handleLogout} /> : <LoginScreen onLoginSuccess={handleLoginSuccess} />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
